import * as React from 'react';
import * as styles from './ContentOrganizerAdmin.css';
import { ContentOrganizerAdminStore } from './stores';
import { inject, observer } from 'mobx-react';
import { IAProgressView } from '../progressView/IAProgressView';
import ContentOrganizerService from '../../services/ContentOrganizerService';
import { IDurableFunctionRuntimeStatus } from '../../interfaces/IDurableFunctionRuntimeStatus';
import { IASpinner } from '../spinner/Spinner';
import { IInstance } from '../../interfaces/IInstance';
import { IProgressViewStatus } from '../../interfaces/IProgressViewStatus';
import { IContentOrganizer, IContentOrganizerCreate } from '../../interfaces/IContentOrganizerCreate';
import { Details } from './tabs/Details';

export interface IProps {
  contentOrganizerAdminStore?: ContentOrganizerAdminStore;
  instance: IInstance;
}

export interface IState {
  currentStep: number;
  loading: boolean;
  status: IProgressViewStatus;
  stepsCompletedWithIssues: number[];
}

@inject('contentOrganizerAdminStore')
@observer
export class ContentOrganizerAdmin extends React.Component<IProps, IState> {

  private readonly totalSteps = 9;
  private interval = undefined;

  constructor(props: IProps) {
    super(props);
    this.state = {
      currentStep: 2,
      loading: true,
      status: IProgressViewStatus.None,
      stepsCompletedWithIssues: []
    };
  }

  public componentDidMount(): void {
    this.checkStatus();
    this.getContentOrganizerInstanceSettings()
  }

  public componentWillUnmount(): void {
    clearInterval(this.interval);
  }

  public componentWillReceiveProps(props: IProps): void {
    if (props.instance !== this.props.instance) {
      // Clear previous interval instance
      clearInterval(this.interval);
      this.interval = undefined;
      this.setState({ loading: true }, () => this.checkStatus());
      this.getContentOrganizerInstanceSettings();
    }
  }

  private async checkStatus(): Promise<void> {
    // Make sure only one interval instance is running
    if (typeof (this.interval) != "number") {
      return await new Promise(() => {
        this.interval = setInterval(async () => {
          let contentOrganizerStatus = await ContentOrganizerService.getContentOrganizerStatus(
            this.props.contentOrganizerAdminStore.environment,
            this.props.contentOrganizerAdminStore.token,
            this.props.contentOrganizerAdminStore.tenant,
            this.props.contentOrganizerAdminStore.instance.instanceName);
          if (this.state.loading !== false) {
            this.setState({ loading: false });
          }
          if (contentOrganizerStatus != undefined) {
            if (this.state.currentStep !== contentOrganizerStatus.customStatus.currentStep) {
              this.setState({ currentStep: contentOrganizerStatus.customStatus.currentStep });
            }
            if (this.state.stepsCompletedWithIssues.length !== contentOrganizerStatus.customStatus.stepsCompletedWithIssues?.length) {
              this.setState({ stepsCompletedWithIssues: contentOrganizerStatus.customStatus.stepsCompletedWithIssues ?? [] })
            }
            if (contentOrganizerStatus.runtimeStatus === IDurableFunctionRuntimeStatus.Completed) {
              clearInterval(this.interval);
              this.setState({ status: IProgressViewStatus.Completed }, () => this.getContentOrganizerInstanceSettings());
            } else if (contentOrganizerStatus.runtimeStatus === IDurableFunctionRuntimeStatus.Failed) {
              clearInterval(this.interval);
              this.setState({ status: IProgressViewStatus.Failed }, () => this.getContentOrganizerInstanceSettings());
            }
          } else {
            clearInterval(this.interval);
            this.setState({ status: IProgressViewStatus.Failed }, () => this.getContentOrganizerInstanceSettings());
          }
        }, 3000);
      });
    }
  }

  private getContentOrganizerInstanceSettings(): void {
    ContentOrganizerService.getContentOrganizerInstanceSettings(this.props.contentOrganizerAdminStore.environment,
      this.props.contentOrganizerAdminStore.token,
      this.props.contentOrganizerAdminStore.tenant,
      this.props.contentOrganizerAdminStore.instance.instanceName).then((instance: IContentOrganizer) => {
        this.props.contentOrganizerAdminStore.selectedInstance = instance;
      });
  }

  private reloadPage() {
    clearInterval(this.interval);
    this.interval = undefined;
    this.checkStatus();
  }

  public render(): JSX.Element {
    return (
      <div className={styles.IA_contentOrganizerAdmin}>
        {this.state.loading &&
          <IASpinner />
        }
        {!this.state.loading && this.state.status === IProgressViewStatus.Completed && this.props.contentOrganizerAdminStore.selectedInstance !== undefined &&
          <Details />
        }
        {!this.state.loading && this.state.status !== IProgressViewStatus.Completed &&
          <IAProgressView
            key={this.props.contentOrganizerAdminStore.instance.instanceName}
            totalSteps={this.totalSteps}
            currentStep={this.state.currentStep}
            stepsCompletedWithIssues={this.state.stepsCompletedWithIssues}
            status={this.state.status}
            onRetry={async () => {
              const payload: IContentOrganizerCreate = this.props.contentOrganizerAdminStore.selectedInstance.settings;
              if (payload) {
                if (!payload.navigator) { payload.navigator = { isFeatureSelected: false } };
                if (!payload.hubSite) { payload.hubSite = { isFeatureSelected: false, id: "", title: "" } };
                await ContentOrganizerService.createContentOrganizer(this.props.contentOrganizerAdminStore.environment, this.props.contentOrganizerAdminStore.token, this.props.contentOrganizerAdminStore.tenant, payload);
                this.setState({
                  status: IProgressViewStatus.None,
                  currentStep: 2,
                  stepsCompletedWithIssues: []
                }, () => this.reloadPage())
                // window.location.reload();
              }
            }}
          />
        }
      </div>
    );
  }

  
}